import { EndpointsType } from './API.endpoints';
import { UseQueryOptions } from '@tanstack/react-query';
import { ResponseType } from 'axios';

export enum QueryParam {
  LOCATION_ID = 'locationId',
  DAYS = 'days',
  DATESTART = 'fromDateIncluded',
  DATEEND = 'toDateIncluded',
}

export enum ErrorStatus {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
}

export interface Pageable {
  sort: Sort;
  offset: 0;
  pageNumber: 0;
  pageSize: 10;
}

export interface Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface ResponseModel<T> {
  content: T;
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number?: number;
  numberOfElements?: number;
  pageable?: Pageable;
  size?: number;
  sort?: Sort;
  totalElements?: number;
  totalPages?: number;
  url?: string;
}

export interface IUseFetchContextData<T> {
  endpoint: EndpointsType | string;
  params?: Record<string, unknown>;
  options?: UseQueryOptions<T>;
  includeContext?: boolean;
  responseType?: ResponseType;
}

export interface IUseFetchData<T> {
  endpoint: EndpointsType | string;
  params?: Record<string, unknown>;
  options?: UseQueryOptions<T>;
  responseType?: ResponseType;
}
export interface IUseFetchMultiData {
  ids: string[];
  endpoint: string;
  options?: {
    enabled?: boolean;
    keepPreviousData?: boolean;
    staleTime?: number;
    cacheTime?: number;
    refetchInterval?: number | false;
    retry?: boolean | number;
  };
  responseType?: 'json' | 'blob' | 'text';
}
